import React from "react";
import Input from "../atoms/Input.jsx";
import FilterSelects from "../molecules/FilterSelects.jsx";
import FilterContainer from "../molecules/FilterContainer.jsx";

const FiltersBar = ({
  searchValue,
  onSearchChange,
  cloudValue,
  onCloudChange,
  statusValue,
  onStatusChange,
  onClear,
  providerOptions = [],
  className = "",
}) => (
  <FilterContainer className={className}>
    <div className="flex flex-col h-full justify-end">
      <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-2">
        Search
      </label>
      <Input
        id="search"
        type="text"
        value={searchValue || ""}
        onChange={onSearchChange}
        placeholder="Search by name, ID, owner or domain..."
        className="w-full text-sm border-gray-300 focus:ring-blue-500 focus:border-blue-500"
      />
    </div>
    <FilterSelects
      cloudValue={cloudValue}
      onCloudChange={onCloudChange}
      statusValue={statusValue}
      onStatusChange={onStatusChange}
      onClear={onClear}
      providerOptions={providerOptions}
    />
  </FilterContainer>
);

export default FiltersBar;
